export const logos = {
  saude10: './assets/logos/LogoSaude10.png',
  agenda: './assets/logos/LogoAgenda.png',
  ammarhesWrite: './assets/logos/LogoAmmarhesWrite.png',
  casaOcupacional: './assets/logos/LogoCasa.png'
}
